import React from 'react';
import { Box, Container } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link, Redirect } from 'react-router-dom';
import { ROUTING_CONFIG, supportArticleRoute, supportCategoryRoute } from '@uplift/constants';
import { Button, ProviderLayout, ProviderLayoutPageHeader, ProviderLayoutPageTitle } from '@uplift/ui-v2';
import { getSupportArticleBySlug, getSupportCategory } from './articles';
import { useSupportArticleStyles } from './articles/article-shared';

export const SupportArticlePage = () => {
  const { slug } = supportArticleRoute.useParams();
  const article = getSupportArticleBySlug(slug);
  const { classes } = useSupportArticleStyles();

  if (!article) {
    return <Redirect to={ROUTING_CONFIG.support} />;
  }

  const ArticleContent = article.Component;
  const category = getSupportCategory(article.category);

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title={(
          <Box>
            <Button
              component={Link}
              to={category ? supportCategoryRoute.createLink({ category: category.category }) : ROUTING_CONFIG.support}
              color="secondary"
              startIcon={<ArrowBack />}
              sx={{ mb: 1, px: 0 }}
            >
              {category ? `Back to ${category.label}` : 'Back to Help Center'}
            </Button>
            <ProviderLayoutPageTitle title={article.title} />
          </Box>
        )}
      />
      <Container className={classes.content}>
        <ArticleContent />
      </Container>
    </ProviderLayout>
  );
};
